import { useContext, useState, useCallback } from "react";
import {
    TextField,
    InputAdornment,
    IconButton,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseIcon from "@mui/icons-material/Close";

import Context from "./context";
import { theme } from "../../theme";

const Html = ({ width, is_filter, onSearch, type}) => {
    const { state, dispatch } = useContext(Context);

    // one object to hold both values
    const [values, setValues] = useState({ text: "", date: "" });

    const updateContext = useCallback((next) => {
        const combined = [next.text, next.date].filter(Boolean).join(" || ");
        dispatch({ type: "SET_SEARCH_TEXT", search_text: combined });
    }, [dispatch]);

    const handleChange = useCallback((key, value) => {
        setValues((prev) => {
            const updated = { ...prev, [key]: value };
            updateContext(updated);
            return updated;
        });
    }, [updateContext]);

    // helper to avoid repeating InputProps
    const commonProps = (key, placeholder, type) => ({
        placeholder,
        variant: "outlined",
        size: "small",
        type,
        value: values[key],
        sx: {
            backgroundColor: theme.main_bg_color,
            borderRadius: "10px",
            width,
            ...(key === "date" ? { ml: 1 } : {}),
        },
        onChange: (e) => handleChange(key, e.target.value),
        InputLabelProps: type === "date" ? { shrink: true } : undefined,
        InputProps: {
            startAdornment:
                key === "text" && !is_filter ? (
                    <InputAdornment position="start">
                        <SearchOutlinedIcon />
                    </InputAdornment>
                ) : undefined,
            endAdornment: (
                <IconButton sx={{ p: "5px" }} onClick={() => handleChange(key, "")}>
                    <CloseIcon />
                </IconButton>
            ),
        },
    });

    return (
        <div style={{ display: "flex", justifyContent: "flex-end", marginRight: 10 }}>
            <TextField {...commonProps("text", !is_filter ? "Search by Keyword..." : "Enter job id")} />
            {type === "date" && (
                <TextField {...commonProps("date", "Select date", "date")} />
            )}

            {is_filter && (
                <IconButton sx={{ p: "5px", ml: 1 }} onClick={() => onSearch(state.search_text)}>
                    <SearchOutlinedIcon />
                </IconButton>
            )}

            {/* <IconButton sx={{ p: "5px", ml: 1 }} onClick={clearAll}>
                <CloseIcon />
            </IconButton> */}
        </div>
    );
};

export default Html;